<div class="stepper-section">
    <div class="each-stepper-section" *ngFor="let step of stepper_details; let index = index" (click)="changeStepper(step)">
		<div class="each-stepper-circle-section">
			<div class="each-stepper-circle" [ngClass]="{ 'each-stepper-circle-selected': selected_step > index }">
				<span>{{ index + 1 }}</span>
			</div>
			<span class="each-stepper-circle-text" [ngClass]="{'each-stepper-circle-text-selected': selected_step > index}">
				{{ step.name }}
				<!-- <span  *ngIf="step.order != 2">({{ getFormattedNumber(step.count) }})</span> -->
				<span>({{ getFormattedNumber(step.count) }})</span>
			</span>
		</div>
      	<p class="stepper-line" *ngIf="index != stepper_details.length - 1" [ngClass]="{ 'stepper-line-selected': selected_step > index + 1 }"></p>
    </div>
</div>
